"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSkeletonContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSkeletonContainer = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  border-radius: 4px;
  gap: ${({ theme }) => theme.spacing(1)};
  overflow: hidden;

  &.skeleton--contrast {
    background-color: white;
    padding: ${({ theme }) => theme.spacing(1)};
  }

  .MuiSkeleton-root {
    transform: none;
    animation: none;
    background-color: ${ui_components_1.baseColors.background000};
    flex-shrink: 0;
  }
`;
